import { connect } from 'react-redux'
import SuperAdmin, { ISuperAdminDispatchProps } from './SuperAdmin'
import { IGlobalState } from '../../Root/store/appReducer'
import {
  getSuperAdminSearchResults,
  getSuperAdminSearchLoading,
  getSuperAdminTotalCount,
  getSuperAdminPage,
  getSuperAdminTargetCompany,
} from './store/SuperAdminSelectors'
import { searchCompanies, setSuperAdminTargetCompany, clearSuperAdminTargetCompany } from './store/SuperAdminActions'

const mapStateToProps = (state: IGlobalState) => ({
  searchResults: getSuperAdminSearchResults(state),
  searchLoading: getSuperAdminSearchLoading(state),
  totalCount: getSuperAdminTotalCount(state),
  page: getSuperAdminPage(state),
  targetCompany: getSuperAdminTargetCompany(state),
})

const mapDispatchToProps: ISuperAdminDispatchProps = {
  searchCompanies,
  setSuperAdminTargetCompany,
  clearSuperAdminTargetCompany,
}

export default connect(mapStateToProps, mapDispatchToProps)(SuperAdmin)
